/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Fallbackname1Inputs */

const id_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil tidak diketahui`)
};

const ms_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil tidak diketahui`)
};

const da_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukendt profil`)
};

const de_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekanntes Profil`)
};

const en_us2_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown profile`)
};

const es_es2_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil desconocido`)
};

const es_mx2_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil desconocido`)
};

const fil_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi kilalang profile`)
};

const fr_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil inconnu`)
};

const it_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo sconosciuto`)
};

const hu_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismeretlen profil`)
};

const nl_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekend profiel`)
};

const no_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukjent profil`)
};

const pl_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieznany profil`)
};

const pt_br2_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil desconhecido`)
};

const pt_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil desconhecido`)
};

const ro_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil necunoscut`)
};

const fi_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuntematon profiili`)
};

const sv_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okänd profil`)
};

const vi_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ không xác định`)
};

const tr_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen profil`)
};

const cs_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámý profil`)
};

const bg_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непознат профил`)
};

const ru_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестный профиль`)
};

const uk_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невідомий профіль`)
};

const ar_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملف شخصي غير معروف`)
};

const hi_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात प्रोफ़ाइल`)
};

const th_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรไฟล์ที่ไม่รู้จัก`)
};

const ja_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不明なプロフィール`)
};

const zh_cn2_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知个人资料`)
};

const zh_hant1_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知個人資料`)
};

const ko_profile_fallbackname1 = /** @type {(inputs: Profile_Fallbackname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알 수 없는 프로필`)
};

/**
* | output |
* | --- |
* | "Unknown profile" |
*
* @param {Profile_Fallbackname1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_fallbackname1 = /** @type {((inputs?: Profile_Fallbackname1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Fallbackname1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_fallbackname1(inputs)
	if (locale === "ms") return ms_profile_fallbackname1(inputs)
	if (locale === "da") return da_profile_fallbackname1(inputs)
	if (locale === "de") return de_profile_fallbackname1(inputs)
	if (locale === "en-US") return en_us2_profile_fallbackname1(inputs)
	if (locale === "es-ES") return es_es2_profile_fallbackname1(inputs)
	if (locale === "es-MX") return es_mx2_profile_fallbackname1(inputs)
	if (locale === "fil") return fil_profile_fallbackname1(inputs)
	if (locale === "fr") return fr_profile_fallbackname1(inputs)
	if (locale === "it") return it_profile_fallbackname1(inputs)
	if (locale === "hu") return hu_profile_fallbackname1(inputs)
	if (locale === "nl") return nl_profile_fallbackname1(inputs)
	if (locale === "no") return no_profile_fallbackname1(inputs)
	if (locale === "pl") return pl_profile_fallbackname1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_fallbackname1(inputs)
	if (locale === "pt") return pt_profile_fallbackname1(inputs)
	if (locale === "ro") return ro_profile_fallbackname1(inputs)
	if (locale === "fi") return fi_profile_fallbackname1(inputs)
	if (locale === "sv") return sv_profile_fallbackname1(inputs)
	if (locale === "vi") return vi_profile_fallbackname1(inputs)
	if (locale === "tr") return tr_profile_fallbackname1(inputs)
	if (locale === "cs") return cs_profile_fallbackname1(inputs)
	if (locale === "bg") return bg_profile_fallbackname1(inputs)
	if (locale === "ru") return ru_profile_fallbackname1(inputs)
	if (locale === "uk") return uk_profile_fallbackname1(inputs)
	if (locale === "ar") return ar_profile_fallbackname1(inputs)
	if (locale === "hi") return hi_profile_fallbackname1(inputs)
	if (locale === "th") return th_profile_fallbackname1(inputs)
	if (locale === "ja") return ja_profile_fallbackname1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_fallbackname1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_fallbackname1(inputs)
	return ko_profile_fallbackname1(inputs)
});
export { profile_fallbackname1 as "profile.fallbackName" }